import React from 'react';
import PropTypes from 'prop-types';
import BrokeredBookingTogglePanel from './BrokeredBookingTogglePanel';
import ChargeOveragesForm from './ChargeOveragesForm';
import PayoutSummaryInfoPanel from '../PayoutSummaryInfoPanel';
import AdminInfoPanel from '../../admin/AdminInfoPanel';

const AdminBrokeredBookingFormSection = (props) => {
  const {
    user,
    location,
    isBrokeredBooking,
    locationChargeOverages,
    chargeOverages,
    customerChargedAmountPerPeriod,
    partnerPayoutAmountPerPeriod,
    overageCustomerChargeRate,
    overagePartnerPayoutRate,
    onCheckBoxChange,
    onBrokeredChange,
    durationType,
    manualPayment,
    setValid
  } = props;

  const securSpaceAmount = customerChargedAmountPerPeriod - partnerPayoutAmountPerPeriod;

  const setBrokeredSettingsIsValid = (isValid) => {
    setValid(!isBrokeredBooking || isValid);
  }

  return (
    <>
      <BrokeredBookingTogglePanel isBrokeredBooking={isBrokeredBooking} onChange={onCheckBoxChange} />
      {
        isBrokeredBooking && <ChargeOveragesForm
          disabled={!location.chargeOverages}
          locationChargeOverages={locationChargeOverages}
          chargeOverages={chargeOverages}
          customerChargedAmountPerPeriod={customerChargedAmountPerPeriod}
          partnerPayoutAmountPerPeriod={partnerPayoutAmountPerPeriod}
          overageCustomerChargeRate={overageCustomerChargeRate}
          overagePartnerPayoutRate={overagePartnerPayoutRate}
          onCheckboxChange={onCheckBoxChange}
          onChange={onBrokeredChange}
          durationType={durationType}
          manualPayment={manualPayment}
          setBrokeredSettingsIsValid={setBrokeredSettingsIsValid}
        />
      }
      <PayoutSummaryInfoPanel
        customerAmount={customerChargedAmountPerPeriod}
        partnerAmount={partnerPayoutAmountPerPeriod}
        securSpaceAmount={securSpaceAmount}
      />
      <AdminInfoPanel user={user} location={location} />
    </>
  );
};

AdminBrokeredBookingFormSection.propTypes = {
  user: PropTypes.object.isRequired,
  location: PropTypes.object,
  isBrokeredBooking: PropTypes.bool.isRequired,
  onCheckBoxChange: PropTypes.func.isRequired,
  onTextChange: PropTypes.func.isRequired,
  durationType: PropTypes.string.isRequired,
};

export default AdminBrokeredBookingFormSection;
